import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import { FindResultType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { mutatorAction } from 'satcheljs';

/**
 * Clears the recipient well
 */
export default mutatorAction('resetRecipientWell', function(
    recipientWell: RecipientWellWithFindControlViewState
) {
    if (recipientWell) {
        // Clear query string from input field.
        recipientWell.queryString = '';

        // Reset the FindResultType
        recipientWell.findResultType = FindResultType.None;
    }
});
